import React from 'react';
import { 
  startOfMonth, endOfMonth, startOfWeek, endOfWeek, 
  eachDayOfInterval, isSameMonth, isSameDay, isToday, 
  format, isBefore, startOfToday 
} from 'date-fns';

const CalendarGrid = ({ currentMonth, selectedDate, onDateSelect }) => {
  const monthStart = startOfMonth(currentMonth);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart);
  const endDate = endOfWeek(monthEnd);
  const today = startOfToday();

  const calendarDays = eachDayOfInterval({ start: startDate, end: endDate });
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <div className="p-4">
      <div className="grid grid-cols-7 mb-2">
        {weekDays.map(day => (
          <div key={day} className="text-center text-xs font-bold text-gray-500 uppercase tracking-wider py-2">
            {day}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {calendarDays.map((day, idx) => {
          const isSelected = selectedDate && isSameDay(day, selectedDate);
          const isCurrentMonth = isSameMonth(day, monthStart);
          const isPast = isBefore(day, today);
          
          return (
            <button
              key={idx}
              disabled={isPast}
              onClick={() => onDateSelect(day)}
              className={`
                relative aspect-square flex flex-col items-center justify-center rounded-xl transition-all duration-300
                ${!isCurrentMonth ? 'text-gray-600' : 'text-gray-300'}
                ${isPast ? 'opacity-20 cursor-not-allowed' : 'hover:bg-blue-600/20 hover:text-white'}
                ${isSelected ? 'bg-gradient-to-br from-blue-600 to-cyan-600 text-white shadow-lg scale-105 z-10' : ''}
                ${isToday(day) && !isSelected ? 'border border-blue-500/50' : ''}
              `}
            >
              <span className="text-sm font-medium">{format(day, 'd')}</span>
              {isToday(day) && !isSelected && (
                <span className="absolute bottom-1.5 w-1 h-1 bg-blue-400 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarGrid;